import { ReactNode } from 'react';

import MedTableV2 from './padV2/MedTableV2';
import onContainerClick from '../../../../pages/prescriptionPad/onClickContainer';
import PadV2PxElementCard from './padV2/PadV2PxElementCard';
import { AdvicesIcon, followUpIcon } from '../../../common/Icons';
import { DIAGNOSIS_KIND, LAB_TESTS_KIND, MEDICINES_KIND, SYMPTOMS_KIND } from '../../trackSource';
import MedicalHistoryCardPadV2 from './padV2/MedicalHistoryCardPadV2';
import ExaminationFindingsCard from '../../leftPanel/ExaminationFindingsCard';
import PPNotesCard from '../../../common/PPNotesCard';
import AddSections from '../../../common/AddSections';
import {
    EL_ID_MH,
    EL_ID_VITALS,
} from '../../../../pages/prescriptionPad/magicBox/magicBoxTableElements';
import FollowUp from '../previewScreen/FollowUp';
import Advices from '../previewScreen/Advices';
import LabVitalV2 from './LabVitalV2';
import VitalsCard from './padV2/VitalsCard';
import AdvicesTranslate from '../../AdvicesTranslate';
import SymDiaV2 from './padV2/SymDiaV2';
import DoctorReferralCard from '../../leftPanel/DoctorReferralCard';
import DentalChart from '../../leftPanel/DentalChart/DentalChart';
import { DentalChartNewUpdateBanner } from '../../leftPanel/DentalChart/Utils';
import MilestoneCard from './padV2/MilestoneCard';
import InjectionModule from './padV2/injections/InjectionModule';
import OpthalTable from './OpthalTable';
import { getColumns, rxKeyToHeadingMap, rxKeyToIconMap } from '../../../../pages/opUtils';
import { NewUpdateComponent } from './NewUpdateComponent';
import OpthalCopyFrom from './OpthalCopyFrom';
import { GlobalState } from '../../../../store/reducers';
import { store } from '../../../../App';
import Procedures from '../../leftPanel/Procedures';
import AdmissionToIPD from './AdmissionToIPD';

const followupIcon = followUpIcon('fill-white');
const advicesIcon = AdvicesIcon('fill-white');

export const EL_ID_FOLLOWUP_ADVICES = 'followup-advices';

export const PAD_COMPONENTS: {
    [key: string]: (sectionName?: string, sectionName1?: string) => ReactNode;
} = {
    'followup-advices': (sectionName?: string, sectionName1?: string) => {
        const state: GlobalState = store.getState();
        const rxDocId = state.prescriptionPad.prescription?.doctor._id;
        if (!rxDocId) return null;
        return (
            <div id={EL_ID_FOLLOWUP_ADVICES}>
                {/* <ConfigureFollowUpAdvicesStrip /> */}

                <div className="grid grid-flow-col auto-cols-fr gap-16 h-296 overflow-hidden">
                    <div key="followup" id="followup" onFocus={onContainerClick} className="h-full">
                        <PadV2PxElementCard
                            icon={followupIcon}
                            headingText={sectionName || 'Follow Up'}
                            iconContainerBgClassName="bg-darwin-neutral-800"
                            bodyCssClassName="space-y-8 rounded-8 h-full"
                        >
                            <FollowUp rxDocId={rxDocId} />
                        </PadV2PxElementCard>
                    </div>
                    <div
                        key="avices"
                        id="avices"
                        onFocus={onContainerClick}
                        className="flex h-full overflow-hidden"
                    >
                        <PadV2PxElementCard
                            icon={advicesIcon}
                            headingText={sectionName1 || 'Advices'}
                            iconContainerBgClassName="bg-darwin-accent-mauve-800"
                            bodyCssClassName="space-y-8 rounded-8 h-full"
                            renderHeaderRight={() => <AdvicesTranslate />}
                        >
                            <Advices rxDocId={rxDocId} />
                        </PadV2PxElementCard>
                    </div>
                    <AdmissionToIPD />
                </div>
            </div>
        );
    },

    symptoms: (sectionName?: string) => (
        <div key={'symptoms'} id={'symptoms'} onFocus={onContainerClick}>
            <SymDiaV2 kind={SYMPTOMS_KIND} sectionName={sectionName} />
        </div>
    ),
    labVitals: (sectionName?: string) => (
        <LabVitalV2 onContainerClick={onContainerClick} sectionName={sectionName} />
    ),
    diagnosis: (sectionName?: string) => (
        <div key="diagnosis" id="diagnosis" onFocus={onContainerClick}>
            <SymDiaV2 kind={DIAGNOSIS_KIND} sectionName={sectionName} />
        </div>
    ),
    medications: (sectionName?: string) => (
        <div key="medications" id="medications" onFocus={onContainerClick}>
            <MedTableV2 kind={MEDICINES_KIND} sectionName={sectionName} />
        </div>
    ),
    injections: () => (
        <div key="injections" id="injections" onFocus={onContainerClick}>
            <InjectionModule />
        </div>
    ),
    labTests: (sectionName?: string) => (
        <div key="labTests" id="labTests" onFocus={onContainerClick}>
            <MedTableV2 kind={LAB_TESTS_KIND} sectionName={sectionName} />
        </div>
    ),
    medicalHistory: (sectionName?: string) => (
        <div key={EL_ID_MH} id={EL_ID_MH} onFocus={onContainerClick}>
            <MedicalHistoryCardPadV2 sectionName={sectionName} />
        </div>
    ),
    examinations: (sectionName?: string) => (
        <div key="examinations" id="examinations" onFocus={onContainerClick}>
            <ExaminationFindingsCard sectionName={sectionName} />
        </div>
    ),
    refer: (sectionName?: string) => (
        <div key="refer" id="refer" onFocus={onContainerClick}>
            <DoctorReferralCard sectionName={sectionName} />
        </div>
    ),
    prescriptionNotes: (sectionName?: string) => (
        <PPNotesCard key="prescriptionNotes" sectionName={sectionName} />
    ),
    dyform: () => <AddSections key="dyform" />,
    vitals: () => (
        <div key={EL_ID_VITALS} id={EL_ID_VITALS} onFocus={onContainerClick}>
            <VitalsCard />
        </div>
    ),
    dentalChart: () => (
        <div key="dentalChart" id="dentalChart" onFocus={onContainerClick}>
            <DentalChartNewUpdateBanner />
            <DentalChart />
        </div>
    ),
    milestones: () => (
        <div key="milestones" id="milestones" onFocus={onContainerClick}>
            <MilestoneCard />
        </div>
    ),
    opVision: () => (
        <div key="milestones" id="milestones" onFocus={onContainerClick}>
            <OpthalTable
                pxKey="opVision"
                heading={rxKeyToHeadingMap['opVision']}
                columns={getColumns('opVision')}
                icon={rxKeyToIconMap['opVision']}
            />
        </div>
    ),
    opIop: () => (
        <OpthalTable
            pxKey="opIop"
            heading={rxKeyToHeadingMap['opIop']}
            columns={getColumns('opIop')}
            icon={rxKeyToIconMap['opIop']}
        />
    ),
    opCurrentSpec: () => (
        <OpthalTable
            pxKey="opCurrentSpec"
            heading={rxKeyToHeadingMap['opCurrentSpec']}
            columns={getColumns('opCurrentSpec')}
            icon={rxKeyToIconMap['opCurrentSpec']}
        />
    ),
    opSubjectiveRefraction: () => (
        <OpthalTable
            pxKey="opSubjectiveRefraction"
            heading={rxKeyToHeadingMap['opSubjectiveRefraction']}
            columns={getColumns('opSubjectiveRefraction')}
            icon={rxKeyToIconMap['opSubjectiveRefraction']}
        />
    ),
    opAutoRefraction: () => (
        <OpthalTable
            pxKey="opAutoRefraction"
            heading={rxKeyToHeadingMap['opAutoRefraction']}
            columns={getColumns('opAutoRefraction')}
            icon={rxKeyToIconMap['opAutoRefraction']}
        />
    ),
    opFinalPrescription: () => (
        <OpthalTable
            pxKey="opFinalPrescription"
            heading={rxKeyToHeadingMap['opFinalPrescription']}
            columns={getColumns('opFinalPrescription')}
            icon={rxKeyToIconMap['opFinalPrescription']}
            renderHeaderRight={() => <OpthalCopyFrom />}
        />
    ),
    procedures: () => (
        <div key="procedures" id="procedures" onFocus={onContainerClick}>
            <Procedures />
        </div>
    ),
};

export const CareCanvasUpdateComponent = () => {
    const LS_KEY_CARE_CANVAS = 'feature/care-canvas';
    return (
        <NewUpdateComponent
            mainText="Introducing CANVAS in EMR! 🖊️ A New Way to Annotate, Explain & Simplify Care"
            subText="Annotate, explain, and simplify care like never before! Use CANVAS to streamline documentation and visually explain conditions to patients. Try it now!"
            lsKey={LS_KEY_CARE_CANVAS}
            trackingEventName="TELL_ME_MORE_CARE_CANVAS"
            element="feature/care-canvas strip"
            url="https://www.youtube.com/embed/DhlDki9jC8M?autoplay=1&mute=1"
            iframeId="care-canvas"
        />
    );
};
